<div class="position-relative overflow-hidden h-100 d-flex">
    <div class="flex-grow-1 overflow-hidden px-sm-4 pt-4">
        <dx-data-grid
            [style]="(`height: calc(100vh - ${offset}px)`)"
            id="creditRequestsHistoryGrid"
            class="grid theme-dependent"
            noDataText=""
            [dataSource]="dataSource"
            [allowColumnResizing]="true"
            [focusedRowEnabled]="true"
            [autoNavigateToFocusedRow]="false"
            [showBorders]="true"
            [remoteOperations]="true"
            [columnAutoWidth]="true"
            [wordWrapEnabled]="true"
            [stateStoring]="{ enabled: true, type: 'localStorage', storageKey: 'credit-requests-history-grid-state', savingTimeout: 0 }"
            (onExporting)="onExporting($event)"
            [customizeColumns]="customizeColumns"
            keyExpr="id"
            width="100%"
        >
            <dxo-scrolling [scrollByContent]="true"></dxo-scrolling>
            <dxo-paging [pageSize]="10"></dxo-paging>
            <dxo-pager [visible]="true" [displayMode]="'full'" [showPageSizeSelector]="true" [showInfo]="true" [showNavigationButtons]="true"></dxo-pager>
            <dxo-load-panel [showPane]="false"></dxo-load-panel>
            <dxo-sorting mode="multiple"></dxo-sorting>
            <dxo-header-filter [visible]="true"></dxo-header-filter>
            <dxo-filter-row [visible]="true" [applyFilter]="'auto'"></dxo-filter-row>
            <dxo-column-chooser height="340px" [enabled]="true" [mode]="'select'">
                <dxo-position my="right top" at="right bottom" of=".dx-datagrid-column-chooser-button"></dxo-position>
                <dxo-search [enabled]="true"></dxo-search>
                <dxo-selection [allowSelectAll]="true" [selectByClick]="true" [recursive]="true"></dxo-selection>
            </dxo-column-chooser>
            <dxo-search-panel [visible]="true" placeholder="Search"></dxo-search-panel>
            <dxo-export [enabled]="true" [formats]="['xlsx']"></dxo-export>

            <dxo-toolbar>
                <dxi-item location="before">
                    <div class="grid-header">History</div>
                </dxi-item>
                <dxi-item location="after" locateInMenu="auto" widget="dxButton"
                    [options]="{ text: 'Filters', icon: 'fa-sharp fa-thin fa-filter', onClick: toggleFilters, stylingMode: 'text' }"></dxi-item>
                <dxi-item location="after" locateInMenu="auto">
                    <div class="separator"></div>
                </dxi-item>
                <dxi-item location="after" locateInMenu="auto" showText="inMenu" widget="dxButton"
                    [options]="{ text: 'Clear Filters', icon: 'fa-sharp fa-thin fa-filter-slash', onClick: clearFilters, stylingMode: 'text' }"></dxi-item>
                <dxi-item location="after" locateInMenu="auto" showText="inMenu" widget="dxButton"
                    [options]="{ text: 'Reset', icon: 'restore', onClick: resetGrid, stylingMode: 'text' }"></dxi-item>
                <dxi-item location="after" locateInMenu="auto">
                    <div class="separator"></div>
                </dxi-item>
                <dxi-item name="columnChooserButton" locateInMenu="auto"></dxi-item>
                <dxi-item name="exportButton"></dxi-item>
            </dxo-toolbar>

            <dxi-column [dataField]="'createdBy.name'" caption="Updated By" cellTemplate="createdBy" [minWidth]="250"></dxi-column>
            <dxi-column [dataField]="gridFieldName('created')" dataType="date" caption="Date" [minWidth]="100" cellTemplate="created" [sortOrder]="'desc'" selectedFilterOperation=">="></dxi-column>
            <dxi-column [dataField]="gridFieldName('status')" caption="Status" [minWidth]="50" cellTemplate="status"
                [lookup]="{ dataSource: statusOptions, valueExpr: 'value', displayExpr: 'text' }" [headerFilter]="{ dataSource: statusOptions }">
            </dxi-column>

            <div *dxTemplate="let cellInfo of 'status'">
                <span class="badge" [ngClass]="getBadgeClass(getCellData(cellInfo).status)">
                    {{ cellInfo.value | creditRequestStatus }}
                </span>
            </div>
            <div *dxTemplate="let cellInfo of 'created'">
                {{ getCellData(cellInfo).created | date: dateTimeFormat }}
            </div>
            <div *dxTemplate="let cellInfo of 'createdBy'">
                <user-avatar-email 
                    [email]="getCellData(cellInfo).createdBy.email"
                    [name]="getCellData(cellInfo).createdBy.name" 
                    [avatarUrl]="getCellData(cellInfo).createdBy.avatarUrl"
                    [employeeId]="getCellData(cellInfo).createdBy.id">
                </user-avatar-email>
            </div>
        </dx-data-grid>
    </div>

    <filter-panel [(isOpened)]="isFilterPanelOpened" (onSearch)="applyFilters()" (onClear)="clearFilters()"
        (pinnedChange)="onPinnedChange()">
        <dx-form [formData]="filterModel">
            <dxi-item [dataField]="'createdBy.name'" editorType="dxTextBox" [editorOptions]="{ placeholder: 'Updated By', stylingMode: 'filled' }"></dxi-item>           
            <dxi-item [dataField]="filterModelName('status')" editorType="dxSelectBox" [editorOptions]="{ placeholder: 'Status', stylingMode: 'filled', items: statusOptions, valueExpr: 'value', displayExpr: 'text', showClearButton: true }"></dxi-item>
            <dxi-item [dataField]="filterModelName('created')" editorType="dxDateBox" [editorOptions]="{ placeholder: 'Request Date', stylingMode: 'filled', displayFormat: 'shortDate' }"></dxi-item>
        </dx-form>
    </filter-panel>
</div>
